import { THEME_PALETTE, THEME_DICTIONARY } from "consts";
import { createTheme } from "@material-ui/core";

export const lightTheme = createTheme({
    palette: {
        type: THEME_DICTIONARY.LIGHT,

        primary: { main: THEME_PALETTE.ttmsBlue },
        secondary: { main: THEME_PALETTE.ttmsBlue },
        background: {
            default: "#ffffff",
        },
    },
});
